import { render, staticRenderFns } from "./ReviewDialog.vue?vue&type=template&id=3a024f00"
import script from "./ReviewDialog.vue?vue&type=script&lang=js"
export * from "./ReviewDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../makeup-web/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports